import { MiscUtil } from '@/utils/miscUtil';
import axios from 'axios';
import qs from 'qs'
export const getOrgList = () => {
  return axios.request({
    url: MiscUtil.getAppPath('usersystemProxy/organization/queryOrgList'),
    method: 'post'
  })
}

export const checkCode = (imageCode) => {
  return axios.request({
    url: 'checkCode',
    params: {
      "imageCode": imageCode
    },
    withCredentials: true,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded' //必须设置传输方式
    }
  })
}
export const registerUser = (data) => {
  return axios.request({
    url: MiscUtil.getAppPath('usersystemProxy/user/addUser'),
    params: data,
    method: 'get',
    withCredentials: true,
    paramsSerializer: function (params) {
      return qs.stringify(params, {
        allowDots: true
      })
    },
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded' //必须设置传输方式
    }
  })
}
export const checkUserName = (userName) => {
  return axios.request({
    url: MiscUtil.getAppPath('usersystemProxy/user/checkUserName'),
    params: {
      "userName": userName
    },
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded' //必须设置传输方式
    }
  })
}
export const checkUserEmail = (userEmail) => {
  return axios.request({
    url: MiscUtil.getAppPath('usersystemProxy/user/checkUserEmail'),
    params: {
      "userEmail": userEmail
    },
    method: 'post'
  })
}
export const queryUserPageList = (data) => {
  return axios.request({
    url: MiscUtil.getAppPath('usersystemProxy/user/queryUserForPage'),
    params: data,
    method: 'get',
    paramsSerializer: function (params) {
      return qs.stringify(params, {
        allowDots: true
      })
    },
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded' //必须设置传输方式
    }
  })
}
export const queryOrgByUserId = (userID) => {
  return axios.request({
    url: MiscUtil.getAppPath('usersystemProxy/user/queryUserAndOrgByID'),
    params: {
      userID
    },
    method: 'get'
  })
}
export const editUsesMark = (userID, usesMark) => {
  return axios.request({
    url: MiscUtil.getAppPath('usersystemProxy/user/editUsesMark'),
    params: {
      "userID": userID,
      "usesMark": usesMark
    },
    method: 'post'
  })
}
export const deleteUser = (userID) => {
  return axios.request({
    url: MiscUtil.getAppPath('usersystemProxy/user/deleteRealUser'),
    params: {
      "userID": userID
    },
    method: 'post'
  })
}
export const resetUserPassword = (userID) => {
  return axios.request({
    url: MiscUtil.getAppPath('usersystemProxy/user/resetUserPassword'),
    params: {
      "userID": userID,
      "md5Flag": true
    },
    method: 'post'
  })
}
export const updatePassword = (userID, password) => {
  return axios.request({
    url: MiscUtil.getAppPath('usersystemProxy/user/updatePassword'),
    params: {
      "userID": userID,
      "password": password,
      "md5Flag":true
    },
    method: 'post'
  })
}
export const editUser = (data) => {
  return axios.request({
    url: MiscUtil.getAppPath('usersystemProxy/user/editUser'),
    params: data,
    method: 'post',
    paramsSerializer: function (params) {
      return qs.stringify(params, {
        allowDots: true
      })
    },
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded' //必须设置传输方式
    }
  })
}

export const queryUserByName = (userName) => {
  return axios.request({
    url: MiscUtil.getAppPath('usersystemProxy/user/queryUserByName'),
    params: {
      userName
    },
    method: 'post'
  })
}
export const queryUserOrg = (orgID) => {
  return axios.request({
    url: MiscUtil.getAppPath('usersystemProxy/user/queryUserAssociationOrg'),
    params: {
      orgID,
      choice: 1,
      userName: ""
    },
    method: 'post'
  })
}
export const queryUserRole = (roleID) => {
  return axios.request({
    url: MiscUtil.getAppPath('usersystemProxy/user/queryUserRoleByProperties'),
    params: {
      roleID,
      choice: 1,
      userName: ""
    },
    method: 'post'
  })
}
export const countUser = () => {
  return axios.request({
    url: MiscUtil.getAppPath('secUser/countSecUser'),
    method: 'post'
  })
}
export const queryUserList = (userUsesMark) => {
  return axios.request({
    url: MiscUtil.getAppPath('usersystemProxy/user/queryUserList'),
    params: {
      userUsesMark
    },
    method: 'post'
  })
}
export const checkPwd = (userName,password) => {
  return axios.request({
    url: MiscUtil.getAppPath('usersystemProxy/user/checkUserByNameAndPwd'),
    params: {
      userName,
      password,
      md5Flag:true
    },
    method: 'post'
  })
}
